const textEncoder = new TextEncoder();

const normalizePem = (value) => String(value || "").replace(/\\n/g, "\n").trim();

const pemToArrayBuffer = (pem) => {
  const base64 = normalizePem(pem)
    .replace("-----BEGIN PUBLIC KEY-----", "")
    .replace("-----END PUBLIC KEY-----", "")
    .replace(/\s+/g, "");

  const binary = window.atob(base64);
  const bytes = new Uint8Array(binary.length);

  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }

  return bytes.buffer;
};

let cachedPublicKeyPromise = null;

const getPublicKey = async (publicKeyPem) => {
  if (!cachedPublicKeyPromise) {
    cachedPublicKeyPromise = window.crypto.subtle.importKey(
      "spki",
      pemToArrayBuffer(publicKeyPem),
      {
        name: "RSASSA-PKCS1-v1_5",
        hash: "SHA-256",
      },
      false,
      ["verify"],
    );
  }

  return cachedPublicKeyPromise;
};

const serializeOtpResponse = (response) =>
  JSON.stringify({
    success: response.success,
    message: response.message,
    data: response.data,
    error: response.error,
  });

export const verifyOtpResponseSignature = async (response, publicKeyPem) => {
  try {
    const signature = response?.signature;

    if (!signature || !publicKeyPem) {
      return false;
    }

    const publicKey = await getPublicKey(publicKeyPem);
    const signatureBytes = Uint8Array.from(window.atob(signature), (char) =>
      char.charCodeAt(0),
    );

    return window.crypto.subtle.verify(
      "RSASSA-PKCS1-v1_5",
      publicKey,
      signatureBytes,
      textEncoder.encode(serializeOtpResponse(response)),
    );
  } catch (error) {
    console.error("Failed to verify OTP response signature:", error);
    return false;
  }
};
